import React from "react";
import { forwardRefAs, Generic } from "../../base";
export const ContentOrderedListItem = forwardRefAs((props, ref) => React.createElement(Generic, Object.assign({ ref: ref }, props)), { as: "li" });
ContentOrderedListItem.displayName = "Content.OrderedList.Item";
//# sourceMappingURL=content-ordered-list-item.js.map